<template>
  <div>
    <div>
      <div v-if="loaded && companyUsers.length === 0">
        <div class="alert alert-primary" role="alert">کاربری یافت نشد.</div>
      </div>
    </div>
    <div v-if="loaded">
      <b-row align-v="center" align-h="between">
        <b-col align-self="center" sm="8" lg="4">
          <b-form-input
            v-model="search.name"
            placeholder="جستجو کاربر بر اساس نام "
            class="mb-3"
            @keypress="notSpace($event)"
            @keydown.enter="updateUsers"
          ></b-form-input>
        </b-col>
        <b-col align-self="center" sm="8" lg="4">
          <b-form-input
            v-model="search.cellphone"
            placeholder="جستجو کاربر بر اساس شماره موبایل"
            class="mb-3"
            maxlength="11"
            @keypress="justNumber($event)"
            @keydown.enter="updateUsers"
          ></b-form-input>
        </b-col>
        <b-col align-v="center" align-h="between" sm="8" lg="4">
          <button
            type="button"
            class="btn btn-primary mb-3"
            title="جستجو"
            @click="updateUsers"
          >
            <i class="fal fa-search pt-1" />
            جستجو
          </button>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
    <div v-if="loaded && companyUsers.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>نام</th>
                <th>تلفن</th>
                <th>تاریخ ثبت‌نام</th>
                <th>عملیات ها</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in companyUsers" :key="user.id">
                <td class="text-nowrap">{{ gFullName(user) || "_" }}</td>
                <td dir="ltr" class="text-nowrap">
                  <a :href="`tel:${user.cellphone}`">
                    {{ prettyPhone(user.cellphone) }}
                  </a>
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(user.created_at) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'company-users-show',
                      params: { id: user.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                  <router-link
                    :to="{
                      name: 'company-users-edit',
                      params: { id: user.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-edit"></i>
                    ویرایش
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="companyUsersPagination.lastPage > 1">
      <b-pagination
        v-model="companyUsersPagination.currentPage"
        :total-rows="companyUsersPagination.total"
        :per-page="companyUsersPagination.perPage"
        aria-controls="my-table"
        @input="updateUsers()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_COMPANY_USERS,
  DESTROY_COMPANY_USER
} from "@/core/services/store/company/users.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "companyUsers",
  data() {
    return {
      loaded: false,
      searchUser: "",
      search: {
        cellphone: "",
        name: ""
      }
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.currentUserProperty.title ?? "شرکت",
        route: { name: "company-dashboard" }
      },
      { title: "کاربران" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "company-users-create" },
          class: "btn-primary"
        }
      ]
    });

    this.updateUsers();
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "companyUsers",
      "companyUsersPagination"
    ])
  },
  methods: {
    updateUsers() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_COMPANY_USERS, {
          name: this.search.name,
          cellphone: this.search.cellphone
        })
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف کاربر اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#1e1f22",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_COMPANY_USER, id).then(() => {
            this.updateUsers();
          });
        }
      });
    }
  }
};
</script>
